import { Grid, Typography } from "@mui/material";
import React from "react";
import hillhouse from "../../Asset/backedbyimg/480px-Hillhouse.png";
import generalatlantic from "../../Asset/backedbyimg/generalatlantic-logo.png";
import ICONIQLogo from "../../Asset/backedbyimg/ICONIQ_Logo.png";
import InsightPartners from "../../Asset/backedbyimg/Insight_Partners_logo.png";
import TigerGlobal from "../../Asset/backedbyimg/Tiger_Global.png";
import transitionlevel from "../../Asset/backedbyimg/transition-level-investments.png";
import {
  BACKED,
  BACKEDBYCONTENT1,
  BACKEDBYCONTENT2,
  BACKEDBYCONTENT3,
  BY,
} from "../../Constant/constant";

export const BackedBy = () => {
  return (
    <Grid container spacing={2} className="home-backedby-container">
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Typography variant="h5" className="home-backedby-header-text">
          {BACKED} &nbsp;
          <span style={{ color: "white" }}>{BY}</span>
        </Typography>
      </Grid>
      <Grid item xs={12} sm={12} md={5.5} lg={5.5} xl={5.5}>
        <Typography variant="h5" className="home-backedby-text">
          {BACKEDBYCONTENT1} &nbsp;
          <span style={{ color: "#2f6df6" }}>{BACKEDBYCONTENT2}</span>
          &nbsp;{BACKEDBYCONTENT3}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={12} md={6.5} lg={6.5} xl={6.5}>
        <Grid
          container
          spacing={2}
          sx={{
            paddingLeft: "80px",
            display: "flex",
            flexWrap: "wrap",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
            <img
              src={generalatlantic}
              className="image-hover"
              alt=""
              height={"45px"}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
            <img
              src={hillhouse}
              className="image-hover"
              alt=""
              height={"55px"}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
            <img
              src={InsightPartners}
              className="image-hover"
              alt=""
              height={"45px"}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <img
              src={ICONIQLogo}
              className="image-hover"
              alt=""
              height={"60px"}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <img
              src={transitionlevel}
              className="image-hover"
              alt=""
              height={"80px"}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <img
              src={TigerGlobal}
              className="image-hover"
              alt=""
              height={"40px"}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
